import { Button, Col, Row } from "react-bootstrap"
import Header from "../components/Header"
import { Link } from "react-router-dom"
import { useEffect, useState } from "react"
import { fetchResearchData } from "../contexts/fetchData"
import { fetchPublications } from "../contexts/fetchPublication"
import { HighlightPublication } from "../components/DBPublications"


// function highlightJournals(str) {
//     let result = str;
//     const journals = ["Nanophotonics", "Nanoscale", "ACS Nano", "Computer Physics Communications", "Nano Letters", "Nature Communications", "Advanced Optical Materials", "Physical Review Letters", "ACS Photonics", "Applied Physics Reviews", "Laser & Photonics Reviews", "Newton 1"]

//     journals.forEach(journal => {
//     const regex = new RegExp(`(${journal})`, "g"); // case-insensitive
//     result = result.replace(
//         regex,
//         `<b><i>$1</i></b>` // wrap the match
//     );
//     });

//     return <span dangerouslySetInnerHTML={{ __html: result }} />;
// }


const PageResearchComp = props => {

    const { children, index } = props;
    
    const [reserachTxt, setTxt] = useState({})
    const [pub, setPub] = useState([]);

    useEffect(() => {
        fetchPublications(setPub);
        return () => {
            setPub([]);
        }
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            const json = await fetchResearchData(index);
            setTxt(json)
        }
        fetchData()
    }, [index])

    
    
    return (
        <div>
            <Header />
            <Row style={{padding: '20px'}}>
                <Col lg={{span: 10, offset: 1}} xs='12'>
                    <div className="main-comp">
                        <h4>{reserachTxt?.title}</h4>
                        <div style={{textAlign: 'justify'}}>{reserachTxt?.description}</div>
                        <br />
                        {children}
                        <br />
                        <div>
                            <h6>Projects</h6>
                            {reserachTxt?.projects?.map((item, index) => (
                                <div key={index}>
                                    [{index + 1}]&nbsp;&nbsp;&nbsp;{item}
                                </div>
                            ))}
                            <br />
                            {/* <h6>References</h6>
                            {reserachTxt?.references?.map((item, index) => (
                                <div key={index}>
                                    [{index + 1}]&nbsp;&nbsp;&nbsp;{highlightJournals(item)}
                                </div>
                            ))}
                            <br /> */}
                            <h6>Recent Publications</h6>
                            {pub.filter(p => p.fields["Theme " + index]).map((item, index) => (
                                <div key={index}>
                                    <span>{`[${item.index}] `}</span>
                                    <HighlightPublication data={item} />
                                </div>
                            ))}
                        </div>
                        <br />
                        <div className="text-end">

                            <Link to={`/research`} style={{ textDecoration: 'none' }}>
                                <Button variant="link" style={{ padding: 0 }}>
                                    Back
                                </Button>
                            </Link>
                        </div>
                    </div>
                    
                </Col>

            </Row>
        </div>
    )
}

const ResearchImages1 = () => {
    const photos = [
        `${process.env.PUBLIC_URL}/directions/1/1.png`,
        `${process.env.PUBLIC_URL}/directions/1/2.png`,
        `${process.env.PUBLIC_URL}/directions/1/3.png`,
    ]

    return (
        <Row>
            {photos.map((item, i) => {
                const colSize = Math.floor(12 / photos.length); // ensure it fits within 12
                return (
                    <Col key={i} xs={12} md={colSize}>
                        <img src={item} alt="" style={{ width: '100%' }} />
                    </Col>
                );
            })}
        </Row> 
    )
}

const ResearchImages2 = () => {
    const photos = [
        `${process.env.PUBLIC_URL}/directions/2/1.png`,
        `${process.env.PUBLIC_URL}/directions/2/2.png`,
        `${process.env.PUBLIC_URL}/directions/2/3.png`,
    ]

    return (
        <Row>
            <Col xs={12} md={3}>
                <img src={photos[0]} alt="" style={{ width: '100%' }} />
            </Col>
            <Col xs={12} md={6}>
                <img src={photos[1]} alt="" style={{ width: '100%' }} />
            </Col>
            <Col xs={12} md={3}>
                <img src={photos[2]} alt="" style={{ width: '100%' }} />
            </Col>
        </Row>
    )
}

const ResearchImages3 = () => {
    const photos = [
        `${process.env.PUBLIC_URL}/directions/3/1.png`,
        `${process.env.PUBLIC_URL}/directions/3/2.png`,
        `${process.env.PUBLIC_URL}/directions/3/3.png`,
    ]

    return (
        <Row>
            <Col xs={12} md={6}>
                <img src={photos[0]} alt="" style={{ width: '100%' }} />
            </Col>
            <Col xs={12} md={4}>
                <img src={photos[1]} alt="" style={{ width: '100%' }} />
            </Col>
            <Col xs={12} md={2}>
                <img src={photos[2]} alt="" style={{ width: '100%' }} />
            </Col>
        </Row>
    )
}

const ResearchImages4 = () => {
    const photos = [
        `${process.env.PUBLIC_URL}/directions/4/1.png`,
        `${process.env.PUBLIC_URL}/directions/4/2.png`,
        `${process.env.PUBLIC_URL}/directions/4/3.png`,
    ]

    return (
        <Row>
            <Col xs={12} md={4}>
                <img src={photos[0]} alt="" style={{ width: '100%' }} />
            </Col>
            <Col xs={12} md={3}>
                <img src={photos[1]} alt="" style={{ width: '100%' }} />
            </Col>
            <Col xs={12} md={5}>
                <img src={photos[2]} alt="" style={{ width: '100%' }} />
            </Col>
        </Row>
    )
}



export { PageResearchComp, ResearchImages1, ResearchImages2, ResearchImages3, ResearchImages4 }